module.exports = __webpack_public_path__ + "img/verspringen.148b73ee.jpg";